<template lang="html">
  <div class="col-lg-9 col-page-content panel-page">

    <div class="row box-panel-top">
      <div class="col-lg-9 col-l">
        <h5 class="box-title">PANEL</h5>

        <div class="box-panel-info">
          <div class="col">
            <h6 class="title">Trabajo aplicados</h6>
            <h4 class="num">{{$root.user.vacancies.length}}</h4>
            <h6 class="title-2">Vacantes a las que aplicaste</h6>
          </div>

          <div class="col">
            <h6 class="title">Trabajos favoritos</h6>
            <h4 class="num">{{$root.user.vacancies_favorites.length}}</h4>
            <h6 class="title-2">Vacantes guardados como favoritos</h6>
          </div>

          <!-- <div class="col">
            <h6 class="title">Alertas creadas</h6>
            <h4 class="num">0</h4>
            <h6 class="title-2">Palabras de seguimiento en puestos de trabajo</h6>
          </div> -->
        </div>
      </div>

      <div class="col-lg-3 pl-lg-0 col-r">
        <!-- <h6 class="box-title">NOTIFICACIONES ACTIVADAS</h6> -->
      </div>
    </div>

    <div class="row box-vacancies">

      <!-- Candidatos que aplicaron recientemente -->
      <div class="col-12 col-vacancies-list">
        <div class="row">

          <div class="col-12 box-acc-title-s1">
            <h4 class="txt-aqua">Vacantes aplicadas</h4>
          </div>

          <div class="col-12 col-jobs-s3" v-for="(job, hjbInx) in $root.user.vacancies" :key="'hjbInx-'+hjbInx">
            <router-link class="box" :to="'/empleos/'+job.empleos_id">
              <div class="col-12 col-vac-info">
                <div>
                  <span>Vacante: {{job.name}}</span>
                  <span>Fecha de aplicación:  {{job.creado}}</span>
                  <!-- <span>Sueldo deseado: -</span> -->
                </div>
              </div>

              <div class="col col-logo">
                <img :src="job.empresa_imageUrl">
              </div>

              <div class="col col-info">
                <h4 class="title">{{ job.name }}</h4>
                <div class="best-companies" v-if="job.best"><span><i class="fas fa-star"></i> Mejores Empresas</span></div>
                <h5><span class="company">{{ job.company }}</span> <i class="loc-icon"></i><span class="location">{{ job.town }},{{ job.state }}.</span></h5>
                <h5 class="extra">{{job.area}}</h5>

              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col-12 col-date">
                <h6>Publicado
                  <span v-if="job.hace_dias != 0">hace {{ job.hace_dias }} días.</span>
                  <span v-else>Hoy.</span>
                </h6>
              </div>
            </router-link>
          </div>

        </div>
      </div>
      <!--  -->

    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      jobs: [
        { empresa_imageUrl: 'public/images/pages/jobs/logo-1.png', hace_dias: 5, best: true, area: 'Sector Médico' ,nombre: 'Ejecutivo de Cuenta', empresa: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-2.png', hace_dias: 0, best: false, area: 'Sector Médico' ,nombre: 'Agente Inmobiliario', empresa: 'Blue Capital', type: 'Freelance', typeColor: '#d8248e' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-3.png', hace_dias: 5, best: true, area: 'Sector Médico' ,nombre: 'Distribuidor', empresa: 'Café Colibrí Artesanal', type: 'Tiempo completo', typeColor: '#0e447b' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-1.png', hace_dias: 5, best: false, area: 'Sector Médico' ,nombre: 'Recepcionista', empresa: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-4.png', hace_dias: 0, best: true, area: 'Sector Médico' ,nombre: 'Estilista Canino', empresa: 'Happy Friends, Estética', type: 'Temporal', typeColor: '#ba0f48' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-5.png', hace_dias: 5, best: false, area: 'Sector Médico' ,nombre: 'Recepcionista', empresa: 'Inntralasik', type: 'Medio tiempo', typeColor: '#f1630d' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-6.png', hace_dias: 5, best: true, area: 'Sector Médico' ,nombre: 'Arquitecto', empresa: 'Promso Constructora', type: 'Tiempo completo', typeColor: '#0e447b' },
        { empresa_imageUrl: 'public/images/pages/jobs/logo-7.png', hace_dias: 5, best: false, area: 'Sector Médico' ,nombre: 'Vendedor de Mostrador', empresa: 'Ganesh, Té de Cacao', type: 'Tiempo completo', typeColor: '#0e447b' },
      ],
    }
  }
}
</script>
 area: Sector Médico'',
